import * as React from 'react';
import type { SVGProps } from 'react';
const SvgGlobe = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18Z"
    />
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.4 3.9h.9a25.581 25.581 0 0 0 0 16.2h-.9m6.3-16.2a25.581 25.581 0 0 1 0 16.2"
    />
    <path
      stroke="#A5A5AA"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M3.9 15.6v-.9a25.581 25.581 0 0 0 16.2 0v.9M3.9 9.3a25.581 25.581 0 0 1 16.2 0"
    />
  </svg>
);
export default SvgGlobe;
